<template>
	<v-menu v-bind="$attrs" v-on="$listeners" hide-details>
		<template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope"><slot :name="slot" v-bind="scope" /></template>
	</v-menu>
</template>
<script>
import AtomsMixins from '@/components/atoms/inputs/common/atoms.mixin.js';
export default { name: 'AppVMenu', mixins: [AtomsMixins] };
</script>
<style scoped lang="scss">
.v-menu__content {
	box-shadow: 0px 3px 6px var(--shadow-color) !important;
	contain: none !important; // this is to allow overflow from menu -- for PublishButtonDropdown overflow arrow
}
</style>
